import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {},
    alert: {
      message: '',
      show: false,
      btnType: 'normal',
      path: '',
      event_id: ''
    },
    loading: false,
    share: false
  },
  getters: {
    user: (state) => {
      return state.user
    },
    alert: (state) => {
      return state.alert
    },
    loading: (state) => {
      return state.loading
    },
    share: (state) => {
      return state.share
    }
  },
  mutations: {
    user: (state) => {
      return state.user
    },
    alert: (state) => {
      return state.alert
    },
    loading: (state) => {
      return state.loading
    },
    share: (state) => {
      return state.share
    }
  },
  actions: {
    user ({ commit }, data) {
      console.log(commit)
      this.state.user = data
    },
    alert ({ commit }, data) {
      console.log(commit)
      this.state.alert = data
    },
    loading ({ commit }, data) {
      console.log(commit)
      this.state.loading = data
    },
    share ({ commit }, data) {
      console.log(commit)
      this.state.share = data
    }
  },
  modules: {
  }
})
